import React from 'react';

export default ({isVisible, showDropzone}) => (
  isVisible ? (
    <a className="btn btn-primary" onClick={showDropzone}><span className="glyphicon glyphicon-paperclip" aria-hidden="true"></span><span className="hidden-xs"> Dokumente hinzufügen</span></a>
  ) : null
);
